import { Stack } from "@mui/material";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { SHIFT_INVITES_FULL_PATH } from "../../WorkerShifts/path";
import {
  SHIFT_DISCOVERY_SEARCH_MODE_SWITCHER_SPACING_BOTTOM,
  SHIFT_DISCOVERY_SEARCH_MODE_SWITCHER_SPACING_HEIGHT,
} from "../SearchModeSwitcher";

interface ViewInvitesButtonProps {
  invitesCount: number;
}

export function ViewInvitesButton(props: ViewInvitesButtonProps) {
  const { invitesCount } = props;

  const history = useHistory();

  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={3}
      sx={(theme) => ({
        position: "absolute",
        zIndex: theme.zIndex.appBar,
        left: 0,
        right: 0,
        // reuse values for shift discovery mode switcher
        bottom: theme.spacing(SHIFT_DISCOVERY_SEARCH_MODE_SWITCHER_SPACING_BOTTOM),
        height: theme.spacing(SHIFT_DISCOVERY_SEARCH_MODE_SWITCHER_SPACING_HEIGHT),
        margin: "0 auto",
      })}
    >
      <Button
        aria-label="View invites"
        size="medium"
        variant="contained"
        sx={(theme) => ({ boxShadow: theme.shadows[3] })}
        onClick={() => {
          history.push(SHIFT_INVITES_FULL_PATH);
        }}
      >
        View invites ({invitesCount})
      </Button>
    </Stack>
  );
}
